export interface ThemeColors {
  primaryMain: string;
  primaryLight: string;
  primaryDark: string;
  primaryHighlight: string;
  primaryLight2: string;
  secondaryMain: string;
  secondaryLight: string;
  secondaryDark: string;
  secondaryHighlight: string;
  secondaryLight2: string;
  background: string;
  grey0: string;
  grey1: string;
  grey2: string;
  grey3: string;
  grey4: string;
  grey5: string;
  grey6: string;
  grey7: string;
  grey8: string;
  grey9: string;
  success1: string;
  success2: string;
  warning1: string;
  warning2: string;
  link1: string;
  link2: string;
  errorMain: string;
  errorHighlight: string;
  errorLight: string;
  greenMain: string;
  greenLight: string;
  blueMain: string;
  blueLight: string;
  skyMain: string;
  orangeMain: string;
  orangeLight: string;
  purpleMain: string;
  purpleLight: string;
  pinkMain: string;
  pinkLight: string;
  turquoiseMain: string;
  turquoiseLight: string;
  qrMain: string;
  qrLight: string;
}

export const DefaultAgColor: ThemeColors = {
  primaryMain: '#374722',
  primaryDark: '#28321B',
  primaryLight: '#576C3C',
  primaryHighlight: '#999933',
  primaryLight2: '#E8E8C1',
  secondaryMain: '#CF9C00',
  secondaryLight: '#E7CD80',
  secondaryDark: '#AD8200',
  secondaryHighlight: '#E5B53C',
  secondaryLight2: '#FFF0C2',
  background: '#FFFFFF',
  link1: '#AD8200',
  link2: '#3182CE',
  grey0: '#FFFFFF',
  grey1: '#F9FAF9',
  grey2: '#F5F5F5',
  grey3: '#EBEBEB',
  grey4: '#D6D6D6',
  grey5: '#A3A3A3',
  grey6: '#858585',
  grey7: '#5C5C5C',
  grey8: '#333333',
  grey9: '#141414',
  success1: '#999933',
  success2: '#689E3C',
  warning1: '#E5B53C',
  warning2: '#E4803B',
  errorMain: '#AD0A00',
  errorHighlight: '#DA463D',
  errorLight: '#FFDAD8',
  greenMain: '#689E3C',
  greenLight: '#D1EBBC',
  blueMain: '#3182CE',
  blueLight: '#CCE6FF',
  skyMain: '#90CDF4',
  orangeMain: '#E4803B',
  orangeLight: '#FFE6D1',
  purpleMain: '#553C9A',
  purpleLight: '#E9E0FF',
  pinkMain: '#D53F8C',
  pinkLight: '#FFCCE6',
  turquoiseMain: '#38B2AC',
  turquoiseLight: '#D7F5F3',
  qrMain: '#3A4925',
  qrLight: '#647938',
};

import store from '../../../redux/store';

export const AgColor: ThemeColors = new Proxy(DefaultAgColor, {
  get: (target, prop: keyof typeof DefaultAgColor) => {
    const state = store.getState();
    const themeColors = state.global.themeColors;
    if (themeColors && themeColors[prop]) {
      return themeColors[prop];
    }
    return target[prop];
  },
});
